export default function VisitsChart({ data = [], loading }) {
  const max = Math.max(1, ...data.map((d) => d.count));

  if (loading) {
    return <p className="text-sm text-slate-500">Cargando gráfico…</p>;
  }

  if (!data.length) {
    return <p className="text-sm text-slate-500">Sin visitas registradas en el período.</p>;
  }

  return (
    <div className="space-y-3">
      <div className="flex h-40 items-end gap-1.5 sm:gap-2" role="img" aria-label="Gráfico de visitas por día">
        {data.map((point) => {
          const barPx = point.count > 0 ? Math.max(6, Math.round((point.count / max) * 128)) : 2;
          const label = point.date.slice(5).replace('-', '/');
          return (
            <div key={point.date} className="flex min-w-0 flex-1 flex-col items-center gap-1">
              <span className="text-[10px] font-medium text-slate-400" title={`${point.count} visitas`}>
                {point.count > 0 ? point.count : ''}
              </span>
              <div
                className="w-full max-w-[2rem] rounded-t-md bg-gradient-to-t from-[#0d2b7f] to-[#1acb12] transition-all"
                style={{ height: `${barPx}px` }}
              />
              <span className="truncate text-[9px] text-slate-500 sm:text-[10px]">{label}</span>
            </div>
          );
        })}
      </div>
      <p className="text-xs text-slate-500">Visitas por día (últimos {data.length} días)</p>
    </div>
  );
}
